export const constants = {

  DEFAULT_VERTICAL_DISTANCE: 80,
  DEFAULT_VERTICAL_LAYOUT_VERTICAL_DISTANCE: 100,

  DEFAULT_VERTICAL_INITIAL_POSITION_OFFSET : {
     y: 232
  },

// padding to detect element placement
  PLACEMENT_DETECTION_PAD: 10,

  NODE_ID_POSITION: {
    top:0,
    right:13
  },

  FLOW_NODE_COLUMN_SIZE: 80,
  FLOW_NODE_MARGIN: 30,

  NEW_TEXT_ROW: 24,
  FILTERS_RIGHT_PANEL_WIDTH: 620,

  EXCLUSIVE_GATEWAY_DIMENSIONS: {
    width: 18,
    height: 18
  },

  NODE_DIMENSIONS: {
    width: 216,
    height: 48
  },
  TREATMENT_NODE_DIMENSIONS: {
    width: 360,
    height: 48
  },

  TREATMENT_NODE_VERTICAL_LAYOUT_DIMENSIONS: {
    width: 216,
    height: 84
  },

  NEIGHBORHOOD_NODE_DIMENSIONS: {
    width: 256,
    height: 48
  },

  OVERLAY_ICON: {
    height: 22,
    width: 32,
    paddingTop: 12
  },

  NEIGHBORHOOD_OVERLAY_ICON_HEIGHT: 11,

  NEIGHBORHOOD_FOCUS_OFFSET_X: 30,
  NEIGHBORHOOD_FOCUS_OFFSET_Y: 50,

  CONNECTION_ICONS_OVERLAYS: {
    left: 10,
    top: 10,
    space:10
  },
  DELETED_CONNECTION_ICONS_OVERLAYS: {
    left: -8,
    top: -8,
    width: 16,
    height: 16
  }
};

export const icons =
  {
    EXPAND_ICON: 'fa fa-fw fa fa-fw fa-angle-down',
    COLLAPSED_ICON: 'fa fa-fw fa fa-fw fa-angle-up',
    EXPAND_ALL_ICON: 'icon__expand_all',
    COLLAPSED_ALL_ICON: 'icon__collapse_all',
    PRIMARY_ICON: 'fa fa-star icon-color-yellow',
    NON_PRIMARY_ICON: 'fa fa-star-o icon-color-grey'
  };

export const markers = {
    MARKER_OK: 'connect-ok',
    MARKER_NOT_OK: 'connect-not-ok'
};

export enum PANEL_MODES {
  COLLAPSED,
  EXPANDED
}
